import React, { lazy, Suspense } from "react";
import { createBrowserRouter, RouterProvider } from "react-router";
import "../index.css";

import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

const WhatsappConnect = lazy(
  () => import(`../pages/WhatsappConnect/WhatsappConnect.page`),
);

const GmailConnect = lazy(() => import(`../pages/Gmail/GmailConnect`));
const OutlookConnect = lazy(() => import(`../pages/Outlook/OutlookConnect`));
const MetaConnect = lazy(() => import(`../pages/Meta/MetaConnect`));

const NotFound = lazy(() => import(`../pages/NotFound/NotFound.page`));

const Loading = () => {
  return (
    <div className="flipping-body">
      <div className="flipping"></div>
    </div>
  );
};

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
    },
  },
});

const createRoute = (path, element) => ({
  path,
  // errorElement: <NotFound />,
  element: <Suspense fallback={<Loading />}>{element}</Suspense>,
});

export const router = createBrowserRouter([
  createRoute("/connect/whatsapp", <WhatsappConnect />),
  createRoute("/connect/gmail", <GmailConnect />),
  createRoute("/connect/outlook", <OutlookConnect />),
  createRoute("/connect/meta", <MetaConnect />),
  {
    path: "*",
    element: <NotFound />,
  },
]);

export default function App() {
  //   const { setSessionId } = useSessionState();
  //   const forceUpdate = useForceUpdate();

  //   useEffect(() => {
  //     setSessionId();
  //   }, [setSessionId]);

  //   useEffect(() => {
  //     actions.core.data({
  //       forceUpdate: forceUpdate,
  //     });
  //   }, []);

  return (
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
    </QueryClientProvider>
  );
}
